import React, { useState, useEffect } from 'react'

import style from './block.module.scss'

const Block = React.forwardRef(({width, height, aspectRatio, background,
                flexDirection, justifyContent, alignItems,
                header, id, children}, ref) => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkScreenSize = () => {
        setIsMobile(window.matchMedia('(max-width: 768px)').matches);
        }

        checkScreenSize()
        
        window.addEventListener('resize', checkScreenSize)
        
        return () => window.removeEventListener('resize', checkScreenSize)
    }, [])

    const config = {
        width: isMobile ? '100vw' : width || 'fit-content',
        height:     height || 'fit-content',
        aspectRation: aspectRatio || '0',
        background: background || '#fff',
        flexDirection: flexDirection || 'row',
        justifyContent: justifyContent || 'center',
        alignItems: alignItems || 'center',
    }

    return (
        <div
            className={style.block}
            style={config}
            id={id ? id : ''}
            ref={ref}
        >
            {(header) &&
            <h2
                className={style.header}
            >
                {header}
            </h2>
            }
            <div
                className={style.children}
            >
                {children}
            </div>
        </div>
    )
})

export default Block